import { UniversalCard } from '@components/core-ui/UniversalCard';
import { ModalNamesEnum } from 'app/types/enums/ModalNamesEnum';
import { useAuthContext } from '@providers/AuthProvider';
import { useModalContext } from '@providers/ModalProvider';
import { routes } from '@routes';
import { MeResponseDtoOrganization, WorkspaceWithStatusesResponseDto } from 'app/API';
import { TWorkspace } from 'app/types/entities/TWorkspace';
import React from 'react';
import { useNavigate } from 'react-router';

export type TProps = {
  workspace: WorkspaceWithStatusesResponseDto;
  organization?: MeResponseDtoOrganization;
  handleWorkspaceClick: (e: React.MouseEvent<HTMLElement, MouseEvent>, workspace: TWorkspace) => void;
};

export type TAction = {
  label: string;
  onClick?: () => void;
  className?: string;
};

export const WorkspaceCard = ({ workspace, organization }: TProps) => {
  const { openModal } = useModalContext();
  const { me } = useAuthContext();
  const navigate = useNavigate();

  const handleDeleteWorkspace = () => {
    openModal(ModalNamesEnum.DeleteWorkspaceModal, { workspace });
  };

  const handleDetails = () => {
    const organization = me.organizations.find((o) => o.id === workspace.organizationId);
    if (organization) {
      navigate(routes.workspaceDetails.make(organization?.slug ?? '', workspace.slug));
    }
  };

  const hasJobs = workspace.jobsProcessing + workspace.jobsReadyForTranscribing + workspace.jobsComplete > 0;
  const actions: TAction[] = [{ label: 'Details', onClick: handleDetails }];
  if (workspace.slug !== 'asone-realtime' && organization?.permissions?.manageWorkspaces && !hasJobs) {
    actions.push({ label: '', className: 'divider' });
    actions.push({ label: 'Remove', className: 'red', onClick: handleDeleteWorkspace });
  }

  const content = (
    <>
      <a
        onClick={(e) => {
          e.preventDefault();
          handleDetails();
        }}
        href={routes.workspaceDetails.make(organization?.slug ?? '', workspace.slug)}
        className="font-medium text-[var(--color-title)] hover:text-foreground-muted"
      >
        {workspace.name || workspace.slug}
      </a>
      <p className="text-foreground-muted text-xs">{organization?.name}&nbsp;</p>
      <p className="text-foreground-muted text-xs">&nbsp;</p>
    </>
  );

  return (
    <UniversalCard
      key={workspace.id}
      content={content}
      name={workspace.name || workspace.slug}
      actions={actions}
      onClick={handleDetails}
    />
  );
};
